export default function resolveFrPhoto(fr = {}) {
  const photoUrl = (fr.photo || '').toString().trim();

  if (/^https?:\/\//gi.test(photoUrl)) {
    return photoUrl;
  }
  return null;
}
